import React, { Component } from 'react';
import FlexLib from '@flex/lib';
import { changeFocus } from '../../helpers/changeFocusCard';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Topheader } from './../../components/Topheader';
import { Grid, TextField, Autocomplete, Button, Container, Alert } from '@mui/material';
import PropTypes from 'prop-types';
import PrintIcon from '@material-ui/icons/Print';
import SaveIcon from '@material-ui/icons/Save';
import Icon from '@material-ui/core/Icon';
import { checkCreditOrDebit, DataGetApiV2, DataPostApiV2, DataPutApiV2 } from '../../helpers/PostDataApi';
import autoFillMultipassFields from '../../helpers/functions/autoFillCardFields';
import config from '../../constants/config';
import { ALL_LOCATION_ERROR } from './../../constants/message';
import { validateZipCode } from '../../helpers/functions/validateZipCode';
import { setupPaymentGatewayProperties } from '../../helpers/functions/paymentGateway.properties.js';
import { Textfield } from './../../components/Textfield';
import { fetchDetails, settingDataByCompanyId, UserDetailById } from '../../actions/AdminUserAction';
import { getInvoiceNumber, getTransactionListTodayData, getCsrfToken } from '../../actions/PaymentAction';
import { uploadInvoiceFile } from '../../actions/RequestFormAction';
import { customerDetailsByCompany, editCustomer } from '../../actions/CustomerAction';
import productsService from '../../services/productsService';
import { Buttons } from './../../components/Buttons';
import { CloseableAlerts } from './../../components/Message/CloseableAlerts';
import LoadingOverlay from 'react-loading-overlay';
import validator from '../../helpers/checkValidations';
import DatePickerInput from '../../components/DatePicker/DatePickerInput.js';
import { setTsepAuth } from '../../actions/LocationAction';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { DialogBox } from './../../components/DialogBox/DialogBox';
import AddCustomerModal from './components/AddCustomerModal.jsx';
import { initialAddressSettings, initialAddressState } from '../../helpers/addressSettingsState';
import classesI from './Invoice.module.scss';
import ProductTable from './components/ProductTable';
import CustomFileDropzone from './components/CustomInvoiceDropzone';
import { getLocationPaymentGateway, validateNotesMarkUp } from '../../helpers/commonFunction';
import commonStrings from '../../constants/commonStrings';
import Stack from '@mui/material/Stack';
import { rules } from '../../constants/IntakeFormConstants';
import { CurrencyFormatterUS } from '../../helpers/currencyFormatters';
import { makePhoneNumberForDB } from '../../helpers/util';
import EditInvoiceConfirmationModal from './EditInvoiceConfirmationModal';
import { whichLocationSelected } from '../../helpers/getLocationFromLocalStorage';
import PrintInvoice from '../../helpers/PrintInvoice';
import AddressFieldsDropDown from '../../components/AddressFieldsDropDown/AddressFieldsDropDown';
import { checkAddressEnabled, validateCityInAddress } from '../../helpers/functions/addressFieldsEnabled';
import { handleAddressSettingError } from '../../helpers/functions/validateAddressfields';
import { isDueDatePassed } from '../../helpers/InvoiceHelper';
import ACHForm from '../../components/ACHForm/ACHForm';
import SelectAccount from '../../components/SelectAccount/SelectAccount';
import TsepCardV2 from '../../components/CardForm/TsepCard';
import PaytraceCard from '../../components/CardForm/PaytraceCard';
import { FlexAlerts, AlertSeverityTypes } from '../../components/Message/Alerts/Alerts';
import AmountTextField from '../../components/FeeDisplay/AmountTextField.jsx';
import FeeDisplay from '../../components/FeeDisplay/FeeDisplay.jsx';
const feeService = new FlexLib.services.FeeService(console);
const mapDatabaseFeeSettings = FlexLib.mappers.feeService.mapDatabaseFeeSettings;
const { sumList, formatCurrencyInput } = FlexLib.utils.feeService;

const mapToFormat = (values) => {
  return values.map((Obj) => ({
    value: Obj._id,
    label: `${Obj.firstName} ${Obj.lastName ?? ''}`,
  }));
};

function TabPanel(props) {
  // eslint-disable-next-line react/prop-types
  const { children, value, index, ...other } = props;
  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`action-tabpanel-${index}`}
      aria-labelledby={`action-tab-${index}`}
      {...other}
    >
      <Box p={3}>{children}</Box>
    </Typography>
  );
}
const useStyles = makeStyles({
  root: {
    width: '100%',
    overflowX: 'auto',
  },
  table: {
    minWidth: 650,
  },
  tableWrapper: {
    width: '100%',
    // overflow: 'auto',
  },
  formControl: {
    marginTop: '2rem',
  },
  '@media (min-width: 800px) and (max-width: 1023px)': {
    tableWrapper: {
      overflowX: 'scroll !important',
    },
  },
});
const getName = (data) => `${data[0]?.firstName} ${data[0]?.lastName || ''}`;

const AddInvoiceInitialState = {
  FRONT_END: 'Invoice',
  invoiceId: '', // ObjectId of the invoice if already created
  messages: [],
  calculationResult: {},
  baseAmount: '',
  paymentType: '',
  currentLocation: {},
  selectedCustomer: {},
  savedPaymentMethods: [],
  selectedPaymentMethod: {},
  ach: {
    isStarted: false,
    isSaveChecked: false,
    accountName: '',
    accountNumber: '',
    routingNumber: '',
    accountType: '',
    bankName: '',
  },
  isDisableInvoice: true,
  redirect: false,
  isPaid: false,
  redirectTransaction: false,
  isLoading: false,
  isEditCustomerModalOpen: false,
  isAddCustomerModalOpen: false,
  multipassCredentials: {},
  lateFee: 0,
  invoice: '',
  createdBy: '',
  linkSendDate: new Date(),
  companyId: '',
  cardWalletID: null,
  tsepFieldError: null,
  tsepFieldSuccess: false,
  tsepSuccessResponse: null,
  tsepAuth: false,
  dueDate: new Date(),
  invoiceDate: new Date(),
  misMatchError: [],
  CoustmerData: [],
  productList: [],
  products: [],
  invoiceFile: [],
  customInvoice: true,
  TransactionData: [],
  updateCard: false,
  tabValue: 0,
  customerId: null,
  errorMessage: {},
  paytraceCredentials: {},
  addCustomInvoiceMode: false,
  openEditConfirmationModal: false,
  name: '',
  mask_number: '',
  PO: '',
  creditOrDebit: null,
  dualFeeEnabled: false,
  card: {
    cardHolderName: '',
    cardNumber: '_______________',
    cardExpiryDate: '__/____',
    cardCsc: '___',
    customerToken: false,
    customerTokenUpdate: false,
  },
  csrf: { 'csrf-token': '', 'csrf-secret': '' },
  userData: { permissions: {} },
  feeSettings: {
    InvoiceDiscount: false,
    InvoiceTax: false,
    virtualTerminalSettings: {},
    invoiceSettings: {},
    DualFeeEnabled: false,
  },
  isSizeMobile: window.innerWidth < 768,
  error: {
    firstNameError: false,
    emailError: false,
    amountError: false,
    phoneError: false,
    lateFeeError: false,
  },
  limit: {
    perTransactionLimit: false,
    dailyTransactionLimit: false,
    perRefundLimit: false,
    dailyRefundLimit: false,
  },
  ...initialAddressSettings,
  ...initialAddressState,
  errorCard: {
    cardNumber: false,
    cardHolderName: false,
    cardExpiryDate: false,
    cardCsc: false,
  },
  invoiceLable: 'Invoice',
  isLateFeeApplicable: false,
  isMobile: false,
  isPaymentButtonDisabled: false,
  binCodesResponse: {},
};

class AddInvoice extends Component {
  constructor(props) {
    super(props);
    this.handleCardChange = this.handleCardChange.bind(this);
    this.handleChangeCheckbox = this.handleChangeCheckbox.bind(this);
    this.handleSubmitAddNewCard = this.handleSubmitAddNewCard.bind(this);
    this.handleSubmitAddCardTsep = this.handleSubmitAddCardTsep.bind(this);
    this.handleTimeout = this.handleTimeout.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = { ...AddInvoiceInitialState };
    this.cardRef = React.createRef();
    this.msgRef = React.createRef();
    this.expiryDateRef = React.createRef();
    this.cscCardRef = React.createRef();
    this.achFormValidationRef = React.createRef(null);
    this.editMode = this.props?.location?.state?.rowData;
  }

  checkAllLocationSelected() {
    const selectedLocation = JSON.parse(localStorage.getItem('selected') || null);
    const userDetails = JSON.parse(localStorage.getItem('user') || '{}');
    if (selectedLocation === 0 && userDetails.permissions.allLocaton) {
      this.setState({ allLocationError: true });
      return true;
    } else {
      this.setState({ allLocationError: false });
      return false;
    }
  }

  componentDidMount() {
    const paymentGateway = getLocationPaymentGateway();
    this.setPaymentGatewayProperties(paymentGateway);
    this.fetchAddressInfo();
    this.setInvoiceDetails();
    this.getCsrfTokens();
    this.checkMobile();
    this.getCustomerList();
    this.checkUserPermissions();
    this.getTransactionsListDailyData();
    this.getProductList();
    this.setUserData();
    this.checkIfInvoiceDisabled();
    this.injectEventListeners();
    this.handleResize();
    this.checkAllLocationError();
    this.getLocationData();
    this.setState({ invoiceDate: new Date(), dueDate: new Date(), linkSendDate: new Date() });

    const currentLocation = whichLocationSelected();
    const jobIdCustomField = currentLocation?.customFields?.find((field) => field?.enabled);
    if (jobIdCustomField && currentLocation?.customFieldsEnabled) {
      this.setState({
        invoiceLable: jobIdCustomField?.value,
        isDisableInvoice: jobIdCustomField?.autoGenerate,
      });
    }
    if (!jobIdCustomField?.autoGenerate && !this.editMode) {
      this.setState({
        newJobId: '',
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.location !== prevProps.location) {
      window.addEventListener('resize', this.handleResize);
    }
    if (this.state.selectedCustomer !== prevState.selectedCustomer) {
      this.setState({ selectedPaymentMethod: {}, savedPaymentMethods: [] });
      this.getPaymentVault();
    }
  }

  getLocationData() {
    const currentLocation = whichLocationSelected();

    if (Object.keys(currentLocation).length > 0) {
      this.setState({ currentLocation });
    }
  }

  getPaymentVault() {
    const getLegacyCard = () => {
      return {
        maskedValue: this.state.selectedCustomer?.masked_card_number,
        paymentType: this.state.selectedCustomer?.creditOrDebit?.toLowerCase() ?? commonStrings.debit,
        accountType: this.state.selectedCustomer?.cardType ? this.state.selectedCustomer?.cardType : 'No Card Type',
        creditOrDebit: this.state.selectedCustomer?.creditOrDebit,
        gatewayPaymentMethodId: this.state.selectedCustomer?.cardWalletID ?? this.state.selectedCustomer?.customer_id,
      };
    };
    if (this.state.currentLocation?.ACHPaymentVault) {
      if (this.state.selectedCustomer?._id?.length > 0) {
        let paymentMethodsArray = [];

        const query = {
          customerId: this.state.selectedCustomer._id,
        };

        DataGetApiV2(config.BASEURL + 'getPaymentVault', query)
          .then((response) => {
            if (response.data?.paymentMethods) {
              // if any paymentMethods are in paymentVault add it to array
              paymentMethodsArray = [...response.data.paymentMethods];
            }
          })
          .catch((_error) => {
            const misMatchError = ['Could not get account data.'];
            this.setState({ misMatchError, selectedPaymentMethod: {} });
          })
          .finally(() => {
            // backwards compatibility with saved card data in customer record
            if (this.state.selectedCustomer?.isCreatedOnGateway && this.state.selectedCustomer?.masked_card_number) {
              paymentMethodsArray.push(getLegacyCard());
            }
            this.setState({ savedPaymentMethods: [...paymentMethodsArray] });
          });
      } else {
        this.setState({ selectedPaymentMethod: {} });
      }
    } else if (this.state.selectedCustomer?.isCreatedOnGateway && this.state.selectedCustomer?.masked_card_number) {
      // add legacy card to payment methods even if no payment vault
      this.setState({ savedPaymentMethods: [getLegacyCard()] });
    }
  }

  setInvoiceDetails() {
    if (this.props?.location?.state?.rowData) {
      const invoiceData = this.props?.location?.state?.rowData;
      this.setInvoiceData(invoiceData);
    } else {
      this.getUniqueInvoiceNumber();
    }
  }

  checkIfInvoiceDisabled() {
    let userData = JSON.parse(localStorage.getItem('user') || '{}');
    const isDisableInvoice = userData.company._id !== '5f62611e3b68d50e56e1000b';
    this.setState({ isDisableInvoice: isDisableInvoice });
  }

  checkUserPermissions() {
    let user = JSON.parse(localStorage.getItem('user') || '{}');
    let data = fetchDetails({ id: user._id });
    data.then((res) => {
      if (res.type === 'FETCH_SUCCESS') {
        this.setState({ userData: { ...res.payload.userData } }, () => {
          if (this.state.userData.permissions && !this.state.userData.permissions.createInvoice) {
            alert('Access denied!');
            this.props.history.push('/Dashboard');
          }
        });
      }
    });
  }

  setUserData() {
    let userData = JSON.parse(localStorage.getItem('user') || '{}');
    this.setState({ createdBy: userData._id, companyId: userData.company._id, isLoading: false }, () => {
      this.settingDataByCompanyId();
    });
  }

  injectEventListeners() {
    document.addEventListener('tsepEventUpdate', this.handleTsepEventUpdated);
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  checkAllLocationError() {
    let misMatchErr = [];
    if (this.checkAllLocationSelected()) {
      misMatchErr.push(ALL_LOCATION_ERROR);
      this.setState({ misMatchErrors: misMatchErr, allLocationError: true });
    } else {
      this.setState({ allLocationError: false });
    }
  }

  setPaymentGatewayProperties(paymentGatewayValue) {
    const { misMatchErrors, paytraceCredentials, multipassCredentials } =
      setupPaymentGatewayProperties(paymentGatewayValue);
    if (misMatchErrors) {
      this.setState({ misMatchErrors });
    } else {
      paymentGatewayValue === 'paytrace'
        ? this.setState({ paytraceCredentials })
        : this.setState({ multipassCredentials });
    }
  }

  handleResize = () => {
    const isMobile = window.innerWidth < 768;
    this.setState({ isMobile });
  };

  checkMobile() {
    const mobileSize = 850; // Set the threshold for mobile size (adjust as needed)
    this.setState({ isSizeMobile: window.innerWidth < mobileSize });
  }

  handleTsepEventUpdated = (event) => {
    const eventTsep = event.detail;
    if (this.state.ach?.isStarted) {
      this.setState({
        ach: { ...this.state.ach, isStarted: false },
        messages: [
          {
            severity: AlertSeverityTypes.warning,
            message: 'Payment type changed to card.',
          },
        ],
      });
    }
    this.setState({ paymentType: this.state.binCodesResponse?.type });
    if (eventTsep.eventType === 'FieldValidationErrorEvent') {
      this.setState({ tsepFieldError: eventTsep.event.message });
    } else if (eventTsep.eventType === 'TokenEvent' && eventTsep.event.status === 'PASS') {
      this.setState({
        tsepSuccessResponse: { ...eventTsep.event },
        tsepFieldSuccess: true,
        tsepFieldError: null,
      });
      // Handle other cases if needed
    } else if (eventTsep.eventType === 'TokenEvent' && eventTsep.event.status === 'FAILURE') {
      this.setState({ tsepFieldError: eventTsep.event.message });
    } else if (eventTsep.eventType === 'FocusOutEvent' && eventTsep.event.fieldName === 'tsep-cardNum') {
      this.setTsepCardPaymentType();
    } else if (
      eventTsep.eventType === 'ErrorEvent' &&
      eventTsep.event.status === 'FAIL' &&
      eventTsep.event.responseCode === 'TSEPERR911'
    ) {
      this.props.setTsepAuth(false);
    }

    // Update your component state with the new card number
    // You might want to use this.setState for this
  };

  setTsepCardPaymentType = () => {
    const cardNumberElement = document.getElementById('tsep-cardNum');
    if (cardNumberElement) {
      const cardNumberValue = cardNumberElement?.value.replace(/\s/g, '');
      this.checkCardPaymentType(cardNumberValue);
    }
  };

  getCardTypeFromBin = (cardInfo) => {
    if (cardInfo.type === 'CHARGE CARD' || cardInfo.card === 'AMERICAN EXPRESS') {
      return 'CREDIT';
    }
    return cardInfo.type;
  };

  checkCardPaymentType = (cardInititals) => {
    checkCreditOrDebit(config.BIN_CHECKER_URL, config.BIN_API_KEY, cardInititals.substring(0, 6))
      .then((result) => {
        this.setState({
          cardType: result.data.card ? result.data.card : null,
          creditOrDebit: result.data.type ? this.getCardTypeFromBin(result.data) : null,
          binCodesResponse: result.data,
        });
      })
      .catch((error) => {
        if (this.state.creditOrDebit !== null) {
          this.setState({ creditOrDebit: null, binCodesResponse: { error: JSON.stringify(error) } });
        } else {
          this.setState({ binCodesResponse: { error: JSON.stringify(error) } });
        }
      });
  };
  setInvoiceData(invoiceInfo) {
    const isLateFeeApplicable = isDueDatePassed(
      invoiceInfo,
      this.state.feeSettings?.invoiceSettings?.CustomFeeOneDueDays
    );
    this.setState({ isLateFeeApplicable: isLateFeeApplicable });
    this.setState({
      ...invoiceInfo,
      ...(invoiceInfo.phone && { phone: makePhoneNumberForDB(invoiceInfo.phone.replace(/[a-z:()._-\s]/gi, '')) }),
      invoiceId: invoiceInfo._id,
      invoiceDate: invoiceInfo.dateOpened,
      selectedCustomer: invoiceInfo.customerId,
      invoice: invoiceInfo.invoice,
      newJobId: invoiceInfo.invoice,
      customInvoice: invoiceInfo.customInvoice,
      addCustomInvoiceMode: !invoiceInfo.customInvoice,
      name: `${invoiceInfo.firstName} ${invoiceInfo?.lastName ? invoiceInfo.lastName : ''}`,
      shippingAddress: invoiceInfo.shippingAddress ? invoiceInfo.shippingAddress : this.state.billingAddress,
      billingAddress: invoiceInfo.billingAddress ? invoiceInfo.billingAddress : this.state.billingAddress,
      products: invoiceInfo.products,
      baseAmount: formatCurrencyInput(invoiceInfo.amount),
      paymentType: '',
    });
  }

  settingDataByCompanyId() {
    this.setState({ isLoading: true });
    let locationId = '';
    if (localStorage.getItem('locationArrIds') !== null) {
      locationId =
        JSON.parse(localStorage.getItem('locationArrIds') || '[]').length > 1
          ? null
          : JSON.parse(localStorage.getItem('locationArrIds') || '[]')[0];
    }
    let param = { id: this.state.companyId, locationId: locationId };
    this.props.settingDataByCompanyId(param).then((res) => {
      this.setState({ isLoading: false });
      if (res.payload.error) {
        //svc disabled
        this.setState({
          feeSettings: {
            InvoiceDiscount: false,
            InvoiceTax: false,
            DiscountFeeName: 'SVC',
            virtualTerminalSettings: {},
            invoiceSettings: {},
            DualFeeEnabled: false,
          },
        });
      } else {
        this.setState(
          {
            feeSettings: {
              ...(res.payload.userData.data ? res.payload.userData.data.response : {}),
              virtualTerminalSettings: {
                ...(res.payload.userData.data ? res.payload.userData.data.response.virtualTerminalSettings : {}),
              },
              invoiceSettings: {
                ...(res.payload.userData.data ? res.payload.userData.data.response.invoiceSettings : {}),
              },
            },
          },
          () => {
            const isLateFeeApplicable = isDueDatePassed(
              this.state,
              this.state.feeSettings?.invoiceSettings?.CustomFeeOneDueDays
            );
            this.setState({ isLateFeeApplicable: isLateFeeApplicable });
            this.setState({
              dualFeeEnabled: this.state.feeSettings.DualFeeEnabled,
            });
          }
        );
      }
    });
  }
  getCsrfTokens() {
    this.props.getCsrfToken().then((res) => {
      this.setState({ csrf: { ...res.payload.paymentData.data } });
    });
  }
  getTransactionsListDailyData() {
    this.setState({ isLoading: true });
    let userDataa = JSON.parse(localStorage.getItem('user') || '{}');
    let dataObj = {
      date: new Date(),
      companyId: userDataa.company ? userDataa.company._id : '',
      role: userDataa.role,
      userId: userDataa._id,
    };
    this.props.getTransactionListTodayData(dataObj).then((response) => {
      if (response) {
        this.setState({
          TransactionData: response.payload.paymentData.data.response,
          isLoading: false,
        });
      }
    });
  }

  handleCardChange(event) {
    let error = {};
    let { id, value } = event.target;
    if (this.state.customerId == null || this.state.customerId === undefined) {
      alert('Select a customer first.');
      document.getElementById('cardNumber').value = '___________';
    } else {
      if (this.state.ach?.isStarted) {
        this.setState({
          ach: { ...this.state.ach, isStarted: false },
          messages: [
            {
              severity: AlertSeverityTypes.warning,
              message: 'Payment type changed to card.',
            },
          ],
        });
      }
      this.setState({ paymentType: this.state.binCodesResponse?.type });
      validator(id, value) ? (error[id + 'Error'] = true) : (error[id + 'Error'] = false);
      if (value.length === 16 && value[value.length - 1] === '_' && id === 'cardNumber' && value[0] === '3') {
        value = value.slice(0, -1);
      }
      if (id === 'cardExpiryDate') {
        const month = value.split('/')[0];
        if (month.length == 2 && (parseInt(month) <= 0 || parseInt(month) > 12)) {
          error[id + 'Error'] = true;
        }
      }
      this.updateCardState(id, value, error);
      changeFocus(id, value, this.expiryDateRef.current, this.cscCardRef.current);
    }
  }
  setCustomJobId(e) {
    if (e.target.value.match(/[%<>\\$'",()|/@#$^&*+=!~`;:?.{}[\]]/)) {
      this.setState({ customFieldInputError: 'Special characters not allowed' });
    } else {
      this.setState({
        newJobId: e.target.value,
        invoice: e.target.value,
        customFieldInputError: null,
      });
    }
  }

  handleChange(event, _t) {
    let error = {};
    let errorMessage = {};
    let misMatchError = [];
    let { id, value } = event.target;
    // Adding error messages in public and private notes
    if (id === 'publicNotes' || id === 'privateNotes') {
      if (validateNotesMarkUp(value)) {
        error[id + 'Error'] = true;
        errorMessage[id + 'ErrorMessage'] = rules.notes.messages.invalidCharacters;
      }
      if (value.length > rules.notes.rule.notesCharacterLimit) {
        error[id + 'Error'] = true;
        errorMessage[id + 'ErrorMessage'] = rules.notes.messages.characterLimit;
      }
      if (error[id + 'Error'] === true) {
        this.setState({ error, errorMessage });
        return false;
      } else {
        error = {};
        errorMessage = {};
        this.setState({ error, errorMessage });
      }
    }

    let errorKey = id + 'Error';
    error[errorKey] = validator(id, value);
    this.setState({
      [id]: value,
      error,
      misMatchError,
      errorCard: { ...this.state.errorCard, [id]: false },
    });
  }

  checkMaxTransactionLimits(val) {
    let maxTransactionLimits = this.props.UserDetail.permissions.perTransactionLimit
      ? this.props.UserDetail.permissions.perTransactionLimit
      : 0;
    let maxDailyTransactionLimits = this.props.UserDetail.permissions.dailyTransactionLimit
      ? this.props.UserDetail.permissions.dailyTransactionLimit
      : 0;
    let maxDailyAmount = this.state.TransactionData.reduce((item, curr) => {
      return item + curr.AMOUNT;
    }, 0);
    if (val > maxDailyTransactionLimits - maxDailyAmount && maxDailyAmount > 0 && maxDailyTransactionLimits > 0) {
      this.setState({ limit: { ...this.state.limit, dailyTransactionLimit: true } }, () => {
        window.scrollTo(0, 0, 0);
        setTimeout(() => {
          this.setState({
            limit: { ...this.state.limit, dailyTransactionLimit: false },
          });
        }, 5000);
        return false;
      });
    } else if (val > maxTransactionLimits && maxTransactionLimits > 0) {
      this.setState({ limit: { ...this.state.limit, perTransactionLimit: true } }, () => {
        window.scrollTo(0, 0, 0);
        setTimeout(() => {
          this.setState({
            limit: { ...this.state.limit, perTransactionLimit: false },
          });
        }, 5000);
        return false;
      });
    } else {
      return true;
    }
  }

  async uploadInvoiceFilesV2(invoiceFiles) {
    if (invoiceFiles?.length > 0) {
      const formData = new FormData();
      if (this.state.invoiceFile && this.state.invoiceFile.length) {
        this.state.invoiceFile &&
          this.state.invoiceFile.forEach((item) => {
            formData.append('invoiceFile', item);
          });
      }
      formData.append('invoice', this.state.invoice);
      formData.append('isCustomInvoicePDF', true);
      return this.props
        .uploadInvoiceFile(formData, true)
        .then(() => {
          console.log('Invoices uploaded.');
        })
        .catch((error) => {
          console.error('Could not upload custom invoices.', error?.message);
        });
    }
    return Promise.resolve();
  }

  handleChangeCustomFiles = (files) => {
    this.setState({ invoiceFile: files });
  };

  checkIsOneTimeCardValid(paymentMethod) {
    if (!paymentMethod?.encrypted_csc || !paymentMethod?.encrypted_number || !paymentMethod?.cardExpiryDate) {
      return false;
    }

    const paymentGateway = getLocationPaymentGateway();
    if (paymentGateway === 'paytrace') {
      if (this.state.card.cardNumber.indexOf('_') > -1) {
        this.setState({
          errorCard: { ...this.state.errorCard, cardNumber: true },
        });
        return false;
      } else if (this.state.card.cardExpiryDate.indexOf('_') > -1) {
        this.setState({
          errorCard: { ...this.state.errorCard, cardExpiryDate: true },
        });
        window.scrollTo(0, 0);
        return false;
      } else if (this.state.card.cardCsc.indexOf('_') > -1) {
        this.setState({ errorCard: { ...this.state.errorCard, cardCsc: true } });
        return false;
      }
    }

    return true;
  }

  async handleSaveDraftV2() {
    const draftInvoicePayload = this.getV2InvoicePayload();
    this.setState({ isLoading: true });
    await this.uploadInvoiceFilesV2(draftInvoicePayload.customInvoiceFiles);

    // If updating existing invoice
    if (this.state.invoiceId?.match(/[0-9a-fA-F]{24}/)) {
      DataPutApiV2(config.BASEURL + `v2/invoices/${this.state.invoiceId}`, draftInvoicePayload)
        .then((response) => {
          this.setState({ messages: [{ severity: AlertSeverityTypes.success, message: response?.data?.message }] });
          this.handleTimeout({
            openEditConfirmationModal: true,
          });
          // Don't return to invoices table since modal is open
        })
        .catch((error) => {
          this.setState({ messages: [{ severity: AlertSeverityTypes.error, message: error.response?.data?.message }] });
        })
        .finally(() => {
          this.setState({ isLoading: false });
        });
    } else {
      DataPostApiV2(config.BASEURL + 'v2/invoices', draftInvoicePayload)
        .then((response) => {
          this.setState({
            invoiceId: response.data.invoiceId,
            messages: [{ severity: AlertSeverityTypes.success, message: response?.data?.message }],
          });
          // Return to invoices table
          setTimeout(() => {
            this.setState({ redirect: true });
          }, 2000);
        })
        .catch((error) => {
          if (error?.response?.data?.invoiceId) {
            this.setState({ invoiceId: error.response.data.invoiceId });
          }
          this.setState({ messages: [{ severity: AlertSeverityTypes.error, message: error.response?.data?.message }] });
        })
        .finally(() => {
          this.setState({ isLoading: false });
        });
    }
    window.scrollTo(0, 0);
  }

  async textInvoice() {
    const textInvoicePayload = this.getV2InvoicePayload();
    this.setState({ isLoading: true });
    await this.uploadInvoiceFilesV2(textInvoicePayload.customInvoiceFiles);

    // If updating existing invoice
    if (this.state.invoiceId?.match(/[0-9a-fA-F]{24}/)) {
      DataPutApiV2(config.BASEURL + `v2/invoices/${this.state.invoiceId}`, textInvoicePayload, {
        sendText: true,
      })
        .then((response) => {
          this.setState({ messages: [{ severity: AlertSeverityTypes.success, message: response?.data?.message }] });
          // Return to invoices table
          setTimeout(() => {
            this.setState({ redirect: true });
          }, 2000);
        })
        .catch((error) => {
          this.setState({ messages: [{ severity: AlertSeverityTypes.error, message: error.response?.data?.message }] });
        })
        .finally(() => {
          this.setState({ openEditConfirmationModal: false, isLoading: false });
        });
    } else {
      DataPostApiV2(config.BASEURL + 'v2/invoices', textInvoicePayload, { sendText: true })
        .then((response) => {
          this.setState({
            invoiceId: response.data.invoiceId,
            messages: [{ severity: AlertSeverityTypes.success, message: response?.data?.message }],
          });
          // Return to invoices table
          setTimeout(() => {
            this.setState({ redirect: true });
          }, 2000);
        })
        .catch((error) => {
          if (error?.response?.data?.invoiceId) {
            this.setState({ invoiceId: error.response.data.invoiceId });
          }
          this.setState({ messages: [{ severity: AlertSeverityTypes.error, message: error.response?.data?.message }] });
        })
        .finally(() => {
          this.setState({ isLoading: false });
        });
    }
    window.scrollTo(0, 0);
  }

  async emailInvoice() {
    const emailInvoicePayload = this.getV2InvoicePayload();
    this.setState({ isLoading: true });
    await this.uploadInvoiceFilesV2(emailInvoicePayload.customInvoiceFiles);

    // If updating existing invoice
    if (this.state.invoiceId?.match(/[0-9a-fA-F]{24}/)) {
      DataPutApiV2(config.BASEURL + `v2/invoices/${this.state.invoiceId}`, emailInvoicePayload, {
        sendEmail: true,
      })
        .then((response) => {
          this.setState({ messages: [{ severity: AlertSeverityTypes.success, message: response?.data?.message }] });
          // Return to invoices table
          setTimeout(() => {
            this.setState({ redirect: true });
          }, 2000);
        })
        .catch((error) => {
          this.setState({ messages: [{ severity: AlertSeverityTypes.error, message: error.response?.data?.message }] });
        })
        .finally(() => {
          this.setState({ openEditConfirmationModal: false, isLoading: false });
        });
    } else {
      DataPostApiV2(config.BASEURL + 'v2/invoices', emailInvoicePayload, { sendEmail: true })
        .then((response) => {
          this.setState({
            invoiceId: response.data.invoiceId,
            messages: [{ severity: AlertSeverityTypes.success, message: response?.data?.message }],
          });
          // Return to invoices table
          setTimeout(() => {
            this.setState({ redirect: true });
          }, 2000);
        })
        .catch((error) => {
          if (error?.response?.data?.invoiceId) {
            this.setState({ invoiceId: error.response.data.invoiceId });
          }
          this.setState({ messages: [{ severity: AlertSeverityTypes.error, message: error.response?.data?.message }] });
        })
        .finally(() => {
          this.setState({ isLoading: false });
        });
    }
    window.scrollTo(0, 0);
  }

  async payInvoice(payInvoicePayload) {
    this.setState({ isLoading: true });
    await this.uploadInvoiceFilesV2(payInvoicePayload.customInvoiceFiles);

    // If updating existing invoice
    if (this.state.invoiceId?.match(/[0-9a-fA-F]{24}/)) {
      DataPutApiV2(config.BASEURL + `v2/invoices/${this.state.invoiceId}`, payInvoicePayload, {
        payInvoice: true,
      })
        .then((response) => {
          this.setState({ messages: [{ severity: AlertSeverityTypes.success, message: response?.data?.message }] });
          // Return to transactions table
          setTimeout(() => {
            this.setState({ redirectTransaction: true });
          }, 2000);
        })
        .catch((error) => {
          this.setState({
            isPaymentButtonDisabled: false,
            messages: [
              {
                severity: AlertSeverityTypes.error,
                message: error.response?.data?.message,
              },
            ],
          });
        })
        .finally(() => {
          this.setState({ openEditConfirmationModal: false, isLoading: false });
        });
    } else {
      DataPostApiV2(config.BASEURL + 'v2/invoices', payInvoicePayload, { payInvoice: true })
        .then((response) => {
          this.setState({
            invoiceId: response.data.invoiceId,
            messages: [{ severity: AlertSeverityTypes.success, message: response?.data?.message }],
          });
          // Return to transactions table
          setTimeout(() => {
            this.setState({ redirectTransaction: true });
          }, 2000);
        })
        .catch((error) => {
          if (error?.response?.data?.invoiceId) {
            this.setState({ invoiceId: error.response.data.invoiceId, isPaymentButtonDisabled: false });
          }
          this.setState({ messages: [{ severity: AlertSeverityTypes.error, message: error.response?.data?.message }] });
        })
        .finally(() => {
          this.setState({ isLoading: false });
        });
    }
    window.scrollTo(0, 0);
  }

  getOneTimeCardPayload() {
    const paymentGateway = getLocationPaymentGateway();
    const paymentMethod = {
      accountName: `${this.state.selectedCustomer?.firstName ?? ''}${
        this.state.selectedCustomer?.firstName && this.state.selectedCustomer?.lastName ? ' ' : ''
      }${this.state.selectedCustomer?.lastName ?? ''}`,
      encrypted_number: '',
      encrypted_csc: '',
      cardExpiryDate: '',
      cardType: this.state.binCodesResponse?.card,
      creditOrDebit: this.state.binCodesResponse?.type,
      binCodesResponse: this.state.binCodesResponse ?? {},
    };

    if (paymentGateway === commonStrings.multipass) {
      const tsepResponse = this.state.tsepSuccessResponse;
      paymentMethod.encrypted_number = tsepResponse ? tsepResponse?.tsepToken : null;
      paymentMethod.encrypted_csc = tsepResponse ? tsepResponse?.cvv2 : null;
      paymentMethod.cardExpiryDate = tsepResponse?.expirationDate;
    } else if (paymentGateway === commonStrings.paytrace) {
      window.paytrace.submitEncrypted('#DemoFormInvoice');
      paymentMethod.encrypted_number = localStorage.getItem('0');
      paymentMethod.encrypted_csc = localStorage.getItem('1');
      paymentMethod.cardExpiryDate = this.state.card?.cardExpiryDate;
      localStorage.removeItem('0');
      localStorage.removeItem('1');
    }

    return paymentMethod;
  }

  getV2InvoicePayload() {
    const payload = {
      invoiceNumber: this.state.invoiceLable == 'Invoice' ? this.state.invoice : this.state.newJobId,
      dueDate: this.state.dueDate,
      PO: this.state.PO,
      baseAmount: formatCurrencyInput(this.state.baseAmount),
      customerId: this.state.selectedCustomer._id,
      billingAddress: {
        addressOne: this.state.billingAddress?.addressOne,
        addressTwo: this.state.billingAddress?.addressTwo,
        city: this.state.billingAddress?.city,
        state: this.state.billingAddress?.state,
        zip: this.state.billingAddress?.zip,
      },
      shippingAddress: {
        addressOne: this.state.shippingAddress?.addressOne,
        addressTwo: this.state.shippingAddress?.addressTwo,
        city: this.state.shippingAddress?.city,
        state: this.state.shippingAddress?.state,
        zip: this.state.shippingAddress?.zip,
      },
      products: [],
      notes: {
        publicNotes: this.state.publicNotes,
        privateNotes: this.state.privateNotes,
        termNotes: this.state.termNotes,
      },
      customInvoiceFiles: [],
    };

    if (this.state.invoiceFile?.length > 0) {
      this.state.invoiceFile.forEach((file) => {
        payload.customInvoiceFiles.push({ path: file?.path });
      });
    }

    if (this.state.products?.length > 0) {
      this.state.products.forEach((item) => {
        const product = {
          _id: item._id,
          name: item.name,
          description: item.description,
          amount: item.amount,
          unitCost: item.unitCost,
          quantity: item.quantity,
          status: item.status,
        };
        payload.products.push(product);
      });
    }

    return payload;
  }

  calculateFees(paymentType) {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const settings = user.settings || {};

    const { feeConfig, options } = mapDatabaseFeeSettings(settings);

    const calculationResult = feeService.getCalculatedFees(
      this.state.baseAmount,
      feeConfig,
      options,
      paymentType?.toLowerCase(),
      this.state.billingAddress?.state
    );
    return calculationResult;
  }

  // If ACHPaymentVault is enabled currently.
  handlePayInvoiceV2(isCashPayment = false) {
    let isValid = true;
    const isVaultEnabled = this.state.currentLocation?.ACHPaymentVault ?? false;
    let paymentType = '';
    let paymentMethod = {};

    if (isCashPayment) {
      paymentType = commonStrings.cash;
    } else if (isVaultEnabled && this.state.selectedPaymentMethod?.paymentType?.toLowerCase() === commonStrings.ach) {
      // Saved ACH account
      paymentType = this.state.selectedPaymentMethod?.paymentType;
      paymentMethod = {
        paymentMethodId: this.state.selectedPaymentMethod?.paymentMethodId,
      };
      isValid = !!paymentMethod.paymentMethodId;
    } else if (
      [commonStrings.credit, commonStrings.debit].includes(this.state.selectedPaymentMethod?.paymentType?.toLowerCase())
    ) {
      // Saved card account - backwards compatible with old gateway
      paymentType = this.state.selectedPaymentMethod?.paymentType;
      if (this.state.selectedPaymentMethod?.paymentMethodId?.length > 0) {
        paymentMethod = {
          paymentMethodId: this.state.selectedPaymentMethod?.paymentMethodId,
        };
      } else {
        paymentMethod = {
          gatewayPaymentMethodId: this.state.selectedPaymentMethod?.gatewayPaymentMethodId,
        };
      }
      isValid = !!paymentMethod.paymentMethodId || !!paymentMethod.gatewayPaymentMethodId;
    } else if (this.state.ach?.isStarted) {
      // One time ACH
      paymentType = commonStrings.ach;
      paymentMethod = {
        accountNumber: this.state.ach.accountNumber,
        routingNumber: this.state.ach.routingNumber,
        accountName: this.state.ach.accountName,
        bankAccountType: this.state.ach.bankAccountType,
        bankName: this.state.ach.bankName,
      };
      isValid = this.achFormValidationRef.current && this.achFormValidationRef.current.validate();
    } else if (this.state.card?.cardNumber?.length > 0) {
      // One time card
      paymentMethod = this.getOneTimeCardPayload();
      paymentType = paymentMethod.creditOrDebit;
      isValid = this.checkIsOneTimeCardValid(paymentMethod);
    }

    if (isValid) {
      this.setState({ paymentType: paymentType, calculationResult: this.calculateFees(paymentType) }, () => {
        const payInvoicePayload = this.getV2InvoicePayload();

        payInvoicePayload.paymentDetails = {
          paymentType: paymentType?.toLowerCase() ?? '',
          paymentMethod: paymentMethod ?? {},
        };
        this.payInvoice(payInvoicePayload);
      });
    } else {
      this.setState({
        openEditConfirmationModal: false,
        isPaymentButtonDisabled: false,
        messages: [{ severity: AlertSeverityTypes.error, message: 'Payment details are incomplete or invalid.' }],
      });
      window.scrollTo(0, 0);
    }
  }

  handleSubmit(e, cashOption = false, _shouldInvoiceUpdate = false) {
    e.preventDefault();
    this.setState({ isPaymentButtonDisabled: true });

    if (
      this.state.isPaid ||
      (this.checkMaxTransactionLimits(this.state.calculationResult?.totalAmount) && this.checkCardValues(this.state))
    ) {
      if (cashOption || this.state.ach.isStarted) {
        this.setState({
          errorCard: {
            ...this.state.errorCard,
            cardExpiryDate: false,
            cardNumber: false,
            cardCsc: false,
          },
        });
      }

      this.handlePayInvoiceV2(cashOption);
    } else {
      this.setState({ isPaymentButtonDisabled: false, openEditConfirmationModal: false });
    }
  }

  updateCardState(id, value, error) {
    let misMatchError = [];
    this.setState(
      {
        card: { ...this.state.card, [id]: value },
        errorCard: { ...this.state.errorCard, [id]: error[id + 'Error'] },
        error,
        misMatchError,
      },
      () => {
        let firstNumber = this.state.card.cardNumber.substring(0, 14);
        if (firstNumber.split('_')[0].length > 5 && id == 'cardNumber') {
          this.checkCardPaymentType(firstNumber);
        }

        if (firstNumber.split('_')[0].length < 6 && id == 'cardNumber' && this.state.creditOrDebit !== null) {
          this.setState({ creditOrDebit: null });
        }
        this.setState({ card: { ...this.state.card } });
      }
    );
  }

  handleSubmitEmailInvoice(e, _t) {
    e.preventDefault();
    const zipCodeError1 = validateZipCode(this.state);
    if (zipCodeError1.length > 0) {
      this.setState({ misMatchError: zipCodeError1 });
      return false;
    }
    const { error, errorFlag, misMatchError } = this.validateFormInputs(true);
    if (errorFlag) {
      this.setState({ misMatchError, error });
      return false;
    } else {
      this.emailInvoice(this.state.ach);
    }
  }

  handleSubmitTextInvoice(e, _t) {
    e.preventDefault();

    const zipCodeError = validateZipCode(this.state);
    if (zipCodeError.length > 0) {
      this.setState({ misMatchError: zipCodeError });
      return false;
    }
    const { error, errorFlag, misMatchError } = this.validateFormInputs(true);
    if (errorFlag) {
      this.setState({ misMatchError, error });
      return false;
    } else {
      this.textInvoice(this.state.ach);
    }
  }

  validateStateElements(misMatchError, error, errorFlag) {
    for (const key of Object.keys(this.state)) {
      const isKeyInvalid = validator(key, this.state[key]);
      if (isKeyInvalid) {
        error[key + 'Error'] = true;
        errorFlag = true;
        misMatchError.push(`Invalid input: ${key}`);
        break;
      } else if (this.state[key] === '' || (typeof this.state[key] === 'string' && this.state[key].trim() === '')) {
        error[key + 'Error'] = true;
        errorFlag = false;
        misMatchError.push(`invalid input: ${key}`);
        break;
      } else {
        error[key + 'Error'] = false;
        errorFlag = false;
      }
    }
    return errorFlag;
  }

  validateFormInputs(bypassAddressSetting) {
    let misMatchError = [];
    let error = {};
    let errorFlag = false;

    const propertiesToDelete = [
      'PO',
      'timestamp_PAID',
      'achDetails',
      'payerName',
      'publicNotes',
      'privateNotes',
      'termNotes',
      'phone',
    ];
    if (
      !this.state.feeSettings?.virtualTerminalSettings?.InvoiceDiscount &&
      !this.state.feeSettings?.virtualTerminalSettings?.DiscountFeeName
    ) {
      propertiesToDelete.push('discountFeeName');
      propertiesToDelete.push('DiscountFeeName');
    }

    propertiesToDelete.forEach((property) => {
      if (this.state[property] === '') {
        delete this.state[property];
      }
    });
    if (this.state.svcFee === 0 || this.state.svcFee == '' || this.state.svcFee === null) {
      delete this.state.svcFee;
    }

    if (this.state.lateFee === 0 || this.state.lateFee == '' || this.state.lateFee === null) {
      delete this.state.lateFee;
    }
    let addressError = '';
    if (!bypassAddressSetting) {
      addressError = handleAddressSettingError(this.state);
      if (addressError.length > 0) {
        errorFlag = true;
        misMatchError = addressError;
        return { misMatchError, errorFlag, error };
      }
    }

    const zipCodeErrorss = validateZipCode(this.state);
    if (zipCodeErrorss.length > 0) {
      errorFlag = true;
      misMatchError = addressError;
      return { misMatchError, errorFlag, error };
    }

    if (this.state.customerId === null) {
      this.openAddCustomer();
      errorFlag = true;
      error = 'Select Customer First.';
      misMatchError.push(error);
      return { misMatchError, errorFlag, error };
    }

    if (this.state.name === '' || !this.state.mask_number) {
      delete this.state.mask_number;
    }

    if (this.state.errorCard.cardExpiryDate) {
      errorFlag = true;
      error = 'Invalid card expiry date';
      misMatchError.push(error);
      return { misMatchError, errorFlag, error };
    }

    errorFlag = this.validateStateElements(misMatchError, error, errorFlag);
    let locationPaydetails = JSON.parse(localStorage.getItem('locationPaydetails') || '{}');

    if (
      !Object.prototype.hasOwnProperty.call(this.state.paytraceCredentials, 'password') &&
      locationPaydetails?.gateway !== 'multipass'
    ) {
      window.scrollTo(0, 0, 0);
      let msg = 'Select the payment location.';
      misMatchError.push(msg);
      this.setState({ misMatchError });
      errorFlag = true;
    }

    return { misMatchError, errorFlag, error };
  }
  handleSubmitAddCardTsep(_e) {
    this.setState({ updateCard: true, cardWalletID: null, tsepFieldSuccess: false });
  }

  handleTimeout(payload, timeout = 500) {
    setTimeout(() => {
      this.setState(payload);
    }, timeout);
  }

  handleSubmitSaveDraft(e, _t) {
    e.preventDefault();
    const paymentGateway = getLocationPaymentGateway();
    if (paymentGateway !== 'multipass') {
      window.paytrace.submitEncrypted('#DemoFormInvoice');
    }

    const zipCodeError = validateZipCode(this.state);
    if (zipCodeError.length > 0) {
      this.setState({ misMatchError: zipCodeError });
      return false;
    }
    const { error, errorFlag, misMatchError } = this.validateFormInputs(true);
    if (errorFlag) {
      this.setState({ ...this.state, misMatchError, error });

      return false;
    } else {
      this.handleSaveDraftV2();
    }
  }

  checkCardValues(state) {
    if (this.state.name === undefined) {
      return false;
    } else if (this.state.name !== '') {
      return true;
    }

    if (state.card.cardNumber.indexOf('_') > -1) {
      this.setState({
        errorCard: { ...this.state.errorCard, cardNumber: true },
      });
      return false;
    } else if (state.card.cardExpiryDate.indexOf('_') > -1) {
      this.setState({
        errorCard: { ...this.state.errorCard, cardExpiryDate: true },
      });
      window.scrollTo(0, 0);
      return false;
    } else if (state.card.cardCsc.indexOf('_') > -1) {
      this.setState({ errorCard: { ...this.state.errorCard, cardCsc: true } });
      return false;
    } else {
      return true;
    }
  }

  getUniqueInvoiceNumber() {
    this.setState({ isLoading: true });
    this.props.getInvoiceNumber().then((res) => {
      this.setState({
        invoice: res.payload.paymentData.data.invoice,
        isLoading: false,
      });

      const currentLocation = whichLocationSelected();
      const jobIdCustomField = currentLocation?.customFields?.find((field) => field?.enabled);
      if (jobIdCustomField?.autoGenerate) {
        this.setState({
          newJobId: res.payload.paymentData.data.invoice,
        });
      }
    });
  }

  getCustomerList() {
    this.setState({ isLoading: true });
    let userData = JSON.parse(localStorage.getItem('user') || '{}');
    const locationPaydetails = JSON.parse(localStorage.getItem('locationPaydetails') || '{}');
    const locations = JSON.stringify([{ locationId: locationPaydetails._id }]);
    let data = {
      role: userData.role,
      userId: userData._id,
      companyId: userData.company._id,
      locations: locations,
    };
    this.props.customerDetailsByCompany(data).then((res) => {
      let selectedCustomer = { ...this.state.selectedCustomer };
      const data = res.payload.customerData.data.response.filter((item) => item._id === selectedCustomer._id);
      this.setState(
        {
          CoustmerData: res.payload.customerData.data.response.filter((customer) => customer.status === true),
          isLoading: false,
          selectedCustomer: data[0],
        },
        () => {
          if (this.props?.location?.state?.rowData) {
            const invoiceData = this.props?.location?.state?.rowData;
            const customerValue = {
              value: invoiceData.customerId.id ?? invoiceData.customerId._id,
              label: invoiceData.customerId.firstName + ' ' + invoiceData.customerId.lastName,
            };
            this.setClientValue(customerValue);
          }
        }
      );
    });
  }

  getProductList() {
    this.setState({ isLoading: true });
    productsService
      .getProductsList()
      .then((response) => {
        this.setState({ productList: response?.data?.products });
      })
      .catch((error) => {
        this.setState({
          messages: [
            {
              severity: AlertSeverityTypes.error,
              message: `Could not fetch products. ${error?.response?.data?.message ?? ''}`,
            },
          ],
        });
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  }

  handleDateChange = (date, key) => {
    if (date) {
      this.setState({ [key]: date });
    } else {
      alert('Date can not be empty!');
      this.setState({ [key]: new Date() });
    }
  };

  openAddCustomer() {
    this.setState({ isAddCustomerModalOpen: true });
  }

  handleClose = () => {
    this.getCustomerList();
    this.setState({ isAddCustomerModalOpen: false, isEditCustomerModalOpen: false, isLoading: true });
  };

  a11yProps(index) {
    return {
      id: `action-tab-${index}`,
      'aria-controls': `action-tabpanel-${index}`,
    };
  }
  handleSubmitAddNewCard(_e) {
    if (Object.keys(this.state.selectedPaymentMethod)?.length > 0) {
      alert('Bank account already selected. Unselect account to enter card details.');
    } else {
      this.setState({
        card: { ...AddInvoiceInitialState.card },
        mask_number: '',
        updateCard: true,
        creditOrDebit: null,
      });
    }
  }

  getAddressDetails(customer) {
    const { shippingAddress, billingAddress } = this.state;
    const data = this.state.CoustmerData.filter((item) => item._id === customer.value);
    if (this.editMode) {
      return { shippingAddress, billingAddress };
    } else {
      const customerShippingAddress = data[0].shippingAddress ? data[0].shippingAddress : shippingAddress;
      const customerBillingAddress = data[0].billingAddress ? data[0].billingAddress : billingAddress;

      return { shippingAddress: customerShippingAddress, billingAddress: customerBillingAddress };
    }
  }
  setClientValue(val) {
    if (val !== null) {
      let misMatchError = [];
      this.setState({
        card: { ...AddInvoiceInitialState.card },
        errorCard: { ...AddInvoiceInitialState.errorCard },
        misMatchError,
        error: { ...this.state.error },
        customerId: val.value,
        creditOrDebit: null,
        shippingAddress: { zip: '', addressOne: '', addressTwo: '', city: '', state: '' },
        billingAddress: { zip: '', addressOne: '', addressTwo: '', city: '', state: '' },
      });

      //For set mask number
      const data = this.state.CoustmerData.filter((item) => item._id === val.value);
      const { shippingAddress, billingAddress } = this.getAddressDetails(val);
      this.setState({ selectedCustomer: data[0] });
      if (data[0]?.customer_id) {
        // THis conditions evaluates wheather customer has been creatd on paymentgateway or not
        const { firstName, lastName } = data[0];
        this.setState({
          cardType: data[0].cardType,
          mask_number: data[0].masked_card_number,
          creditOrDebit: data[0]?.creditOrDebit,
          shippingAddress,
          billingAddress: validateCityInAddress(billingAddress),
          cardWalletID: data[0]?.cardWalletID,
          name: `${firstName} ${lastName ?? ''}`,
          customerCode: data[0]?.customerCode,
        });

        if (this.editMode === undefined) {
          this.setState({
            name: getName(data),
          });
        }
      } else {
        let namee = getName(data);
        this.setState({
          cardWalletID: null,
          mask_number: '',
          name: namee,
          updateCard: false,
          shippingAddress,
          billingAddress: validateCityInAddress(billingAddress),
        });
      }
    } else {
      let misMatchError = [];
      const cardElement = document.getElementById('cardNumber');
      if (cardElement) {
        cardElement.value = '___________';
      }
      this.setState({
        card: { ...AddInvoiceInitialState.card },
        ach: { ...AddInvoiceInitialState.ach },
        misMatchError,
        errorCard: { ...AddInvoiceInitialState.errorCard },
        customerId: null,
        cardWalletID: null,
        creditOrDebit: null,
        selectedCustomer: {},
        shippingAddress: { zip: '', addressOne: '', addressTwo: '', city: '', state: '' },
        billingAddress: { zip: '', addressOne: '', addressTwo: '', city: '', state: '' },
        selectedPaymentMethod: AddInvoiceInitialState.selectedPaymentMethod,
        savedPaymentMethods: AddInvoiceInitialState.savedPaymentMethods,
      });
    }
  }

  handleChangeCheckbox(event) {
    this.setState({
      card: { ...this.state.card, [event.target.id]: event.target.checked },
    });
  }

  setEditClient() {
    this.setState({ isEditCustomerModalOpen: true });
  }

  setNewProducts = (newProducts) => {
    // Calculate new base amount
    const totalProductsBaseAmount = sumList(newProducts, 'amount');

    // Set products
    this.setState({ baseAmount: totalProductsBaseAmount, products: newProducts });
  };

  removeCloseableMessage = (index) => {
    let misMatchError = this.state.misMatchError;
    delete misMatchError[index];
    this.setState({ misMatchError });
  };

  handlePrint = () => {
    PrintInvoice({
      ...this.state,
      customInvoiceName: this.state.invoiceLable,
      discountFeeName: this.state.feeSettings?.virtualTerminalSettings?.DiscountFeeName,
      isSurchargeApplied: !!this.state.feeSettings?.virtualTerminalSettings?.InvoiceSurcharge,
    });
  };

  fetchAddressInfo() {
    const userDetails = JSON.parse(localStorage.getItem('user') || '{}');
    this.props.UserDetailById({ id: userDetails?._id }).then((resp) => {
      if (resp.type === 'USER_SUCCESS' && resp.payload.userData.status === 200) {
        this.setState((prevState) => ({
          addressSettings: {
            ...prevState.addressSettings,
            shippingAddress: resp.payload.userData.data.settings?.invoiceSettings?.shippingAddress,
            billingAddress: resp.payload.userData.data.settings?.invoiceSettings?.billingAddress,
          },
        }));
      }
    });
  }

  handleChangeAddress = (event, type, isBillingAddressSameAsShippingAddress = false) => {
    let { id, value } = event.target;
    if (type === 'shippingAddress' || isBillingAddressSameAsShippingAddress) {
      const addressShipping = {
        ...this.state.shippingAddress,
        [id]: value,
      };
      this.setState({ shippingAddress: addressShipping });
    }
    if (type === 'billingAddress') {
      const billingAddress = {
        ...this.state.billingAddress,
        [id]: value,
      };
      this.setState({ billingAddress });
    }
  };

  handleIsBillingAddressSameAsShippingAddress = (isBillingAddressSameAsShippingAddress = false) => {
    if (isBillingAddressSameAsShippingAddress) {
      this.setState({ shippingAddress: { ...this.state.billingAddress } });
    }
  };

  handleChangeACH = (event, _val) => {
    let { id, value } = event.target;

    if (!this.state.ach?.isStarted) {
      this.setState((prevState) => ({
        ach: { ...prevState.ach, isStarted: true },
        paymentType: 'ach',
        messages: [
          {
            severity: AlertSeverityTypes.warning,
            message: 'Payment type changed to ACH.',
          },
        ],
      }));
    }

    this.setState((prevState) => ({
      ach: { ...prevState.ach, [id]: value },
    }));
  };

  handleSelectAccount(selectedAccountDetails) {
    if (selectedAccountDetails) {
      let accountDetails = {
        ...selectedAccountDetails,
        accountNumber: selectedAccountDetails.maskedValue,
      };
      if (selectedAccountDetails.paymentType === commonStrings.ach) {
        this.setState({
          messages: [],
          selectedPaymentMethod: { ...accountDetails },
          card: { ...AddInvoiceInitialState.card },
          ach: { ...this.state.ach, isStarted: true, ...accountDetails },
          paymentType: selectedAccountDetails.paymentType,
        });
      } else {
        this.setState({
          messages: [],
          selectedPaymentMethod: { ...accountDetails },
          card: { ...AddInvoiceInitialState.card },
          ach: { ...AddInvoiceInitialState.ach },
          creditOrDebit: accountDetails?.creditOrDebit, // get surcharge
          paymentType: selectedAccountDetails.paymentType,
        });
      }
    } else {
      // if removing selected account
      this.setState({
        ach: { ...AddInvoiceInitialState.ach, isStarted: false },
        selectedPaymentMethod: {},
        messages: [],
        paymentType: '',
      });
    }
  }

  handleBaseAmountChange = (newBaseAmount) => {
    this.setState({ baseAmount: newBaseAmount });
  };

  updateArchiveStatus = (isArchived) => {
    const draftInvoicePayload = {
      baseAmount: formatCurrencyInput(this.state.baseAmount),
      isArchived,
      customerId: this.state.selectedCustomer._id,
    };
    this.setState({ isLoading: true });

    let archiveMessage = isArchived ? 'Invoice archived.' : 'Invoice restored!';

    if (this.state.invoiceId?.match(/[0-9a-fA-F]{24}/)) {
      DataPutApiV2(config.BASEURL + `v2/invoices/${this.state.invoiceId}`, draftInvoicePayload)
        .then(() => {
          this.setState({ messages: [{ severity: AlertSeverityTypes.success, message: archiveMessage }] });
          this.setState({ isArchived });
        })
        .catch((error) => {
          this.setState({ messages: [{ severity: AlertSeverityTypes.error, message: error.response?.data?.message }] });
        })
        .finally(() => {
          this.setState({ isLoading: false });
        });
    } else {
      this.setState({
        messages: [{ severity: AlertSeverityTypes.error, message: 'No invoice id to update invoice status.' }],
      });
      this.setState({ isLoading: false });
    }
    window.scrollTo(0, 0);
  };

  getCardDisplayData() {
    if (
      [commonStrings.credit, commonStrings.debit].includes(this.state.selectedPaymentMethod?.paymentType?.toLowerCase())
    ) {
      return {
        showCardInput: false,
        accountType: this.state.selectedPaymentMethod?.accountType,
        maskedCardNumber: this.state.selectedPaymentMethod?.maskedValue,
      };
    } else if (this.state.selectedPaymentMethod?.paymentType === commonStrings.ach) {
      return { showCardInput: false, headerText: 'No Card Selected' };
    } else {
      // no paymentMethod selected
      return { showCardInput: true };
    }
  }

  render() {
    const maxDailyAmount = this.state.TransactionData.reduce((item, curr) => {
      return item + curr.AMOUNT;
    }, 0);
    const { classes, t } = this.props;
    const { CoustmerData, redirect, redirectTransaction, isSizeMobile } = this.state;
    const rowData = this.props?.location?.state?.rowData;
    const paymentGateway = getLocationPaymentGateway();
    if (paymentGateway === 'multipass') {
      autoFillMultipassFields();
    }
    return (
      <div className="rightPanel">
        {redirect ? <Redirect to="/Invoices" /> : ''}
        {redirectTransaction ? <Redirect to="/Transactions" /> : ''}
        <Topheader />
        <div className="contentPart">
          <LoadingOverlay
            className={classes.tpTableFullW}
            active={this.state.isLoading}
            spinner
            text="Fetching your response ..."
          >
            <Container component="main" maxWidth={false}>
              <Stack sx={{ width: '100%' }} spacing={2}>
                {this.state.misMatchError?.map((e, i) => (
                  <CloseableAlerts
                    key={i}
                    index={i}
                    message={e}
                    severity="error"
                    closer={this.removeCloseableMessage}
                  />
                ))}
                {this.state.isArchived && (
                  <Alert severity="info">This invoice is archived. Please restore it to make changes.</Alert>
                )}
              </Stack>
              {this.state.limit.perTransactionLimit ? (
                <h3 className="errorMsg">
                  <span>Warning : </span>Your per transaction limit is $
                  {this.props.UserDetail.permissions.perTransactionLimit
                    ? this.props.UserDetail.permissions.perTransactionLimit
                    : 0}{' '}
                </h3>
              ) : (
                ''
              )}
              {this.state.limit.dailyTransactionLimit ? (
                <h3 className="errorMsg">
                  <span>Warning : </span>Your daily transaction limit is{' '}
                  {this.props.UserDetail.permissions.dailyTransactionLimit
                    ? CurrencyFormatterUS(this.props.UserDetail.permissions.dailyTransactionLimit)
                    : 0}
                  .You have already made the payment of {CurrencyFormatterUS(maxDailyAmount)}, Make a payment less than{' '}
                  {CurrencyFormatterUS(this.props.UserDetail.permissions.dailyTransactionLimit - maxDailyAmount)}.
                </h3>
              ) : (
                ''
              )}
              <DialogBox
                open={this.state.isAddCustomerModalOpen}
                handleClose={this.handleClose}
                message={<AddCustomerModal />}
              />
              <DialogBox
                open={this.state.isEditCustomerModalOpen}
                handleClose={this.handleClose}
                message={<AddCustomerModal editData={this.state.customerId} />}
              />

              <form className={classes.form} id="DemoFormInvoice" ref={this.msgRef}>
                <Grid container id="fullPage">
                  <Grid container columnSpacing={4} rowSpacing={3} id="topSection">
                    {this.state.tsepFieldError && (
                      <Grid item xs={12} md={12}>
                        <FlexAlerts
                          messages={[{ message: this.state.tsepFieldError, severity: AlertSeverityTypes.error }]}
                        />
                      </Grid>
                    )}

                    <Grid item xs={12} md={12} id="alerts">
                      <FlexAlerts messages={this.state.messages} />
                    </Grid>
                    <Grid item container xs={12} md={8} columnSpacing={4} rowSpacing={3} id="leftTop">
                      <Grid item container columnSpacing={4} rowSpacing={3} id="leftTopLine">
                        <Grid item container xs={12} md={6} id="selectCustomer">
                          <Grid item xs={12} md={12}>
                            <Autocomplete
                              id="selectCustomerName"
                              renderInput={(params) => <TextField {...params} label={'Customer Name'} />}
                              getOptionKey={(option) => option.value}
                              isOptionEqualToValue={(option, value) => !value || option.value === value.value}
                              options={mapToFormat(CoustmerData)}
                              onChange={(_e, val) => this.setClientValue(val)}
                              value={
                                rowData || this.state.selectedCustomer
                                  ? {
                                      value: this.state.selectedCustomer?._id,
                                      label: `${this.state.selectedCustomer?.firstName ?? ''} ${
                                        this.state.selectedCustomer?.lastName
                                          ? this.state.selectedCustomer.lastName
                                          : ''
                                      }`,
                                    }
                                  : null
                              }
                            />
                          </Grid>
                          <Grid item xs={12} md={12}>
                            {this.state?.customerId !== null &&
                            this.state?.customerId !== 'undefined' &&
                            this.state?.customerId?._id !== '' &&
                            this.state?.customerId?._id !== 'undefined' ? (
                              <Button
                                className={classesI.addNewClient}
                                variant="contained"
                                color="primary"
                                onClick={(e) => {
                                  this.setEditClient(e);
                                }}
                              >
                                {t('EditCustomer')}
                              </Button>
                            ) : (
                              <Button
                                className={classesI.addNewClient}
                                variant="contained"
                                color="primary"
                                text={t('AddNewCustomer')}
                                onClick={() => {
                                  this.openAddCustomer();
                                }}
                              >
                                {t('AddNewCustomer')}
                              </Button>
                            )}
                          </Grid>
                        </Grid>
                        <Grid item xs={12} md={6} id="selectPaymentMethod">
                          <SelectAccount
                            paymentMethods={this.state.savedPaymentMethods}
                            selectAccount={(option) => {
                              this.handleSelectAccount(option);
                            }}
                            selectedAccount={this.state.selectedPaymentMethod}
                            showType={'all'}
                          />
                        </Grid>
                      </Grid>
                      <Grid item container xs={12} md={12} columnSpacing={4} rowSpacing={2} id="accountInfo">
                        <Grid item xs={12} md={this.state.currentLocation?.ACH ? 6 : 10} id="cardInfo">
                          <>
                            <Typography component="h2" gutterBottom>
                              Card Details
                            </Typography>
                            {paymentGateway === commonStrings.multipass && (
                              <TsepCardV2
                                handleChangeCheckbox={this.handleChangeCheckbox}
                                customerToken={this.state.card?.customerToken}
                                customerTokenUpdate={this.state.card?.customerTokenUpdate}
                                updateCard={this.state.updateCard}
                                tsepAuth={this.props.LocationCurrent?.tsepAuth}
                                displayCardDetails={this.getCardDisplayData()}
                              />
                            )}
                            {paymentGateway === commonStrings.paytrace && (
                              <PaytraceCard
                                card={this.state.card}
                                cardErrors={this.state.errorCard}
                                cardRef={this.cardRef}
                                expiryDateRef={this.expiryDateRef}
                                cscCardRef={this.cscCardRef}
                                handleChangeCard={this.handleCardChange}
                                handleChangeCheckbox={this.handleChangeCheckbox}
                                displayCardDetails={this.getCardDisplayData()}
                              />
                            )}
                          </>
                        </Grid>

                        {this.state.currentLocation?.ACH && (
                          // if a saved account is selected, only show this if paymentType is ach
                          <Grid item xs={12} md={6} id="achInfo">
                            <Typography component="h2" gutterBottom>
                              ACH Details
                            </Typography>
                            <ACHForm
                              ach={this.state.ach}
                              handleChangeACH={(e, val) => this.handleChangeACH(e, val)}
                              variant="detailedBlock"
                              location={this.state.currentLocation}
                              ref={this.achFormValidationRef}
                              disabled={Object.keys(this.state.selectedPaymentMethod)?.length > 0}
                            />
                          </Grid>
                        )}
                      </Grid>
                      <Grid item>{/* spacing */}</Grid>
                    </Grid>
                    <Grid
                      item
                      container
                      xs={12}
                      md={4}
                      columnSpacing={3}
                      rowSpacing={2}
                      alignContent={'flex-start'}
                      id="rightTop"
                    >
                      <Grid item xs={12} md={12} id="invoiceId">
                        <TextField
                          required={true}
                          error={
                            this.state.invoiceLable !== 'Invoice'
                              ? this.state.error.newJobIdError
                              : this.state.error.invoiceError
                          }
                          id="invoice"
                          data-cy="invoice-number"
                          type="text"
                          label={this.state.invoiceLable}
                          value={this.state.invoiceLable == 'Invoice' ? this.state.invoice : this.state.newJobId}
                          disabled={this.state.isDisableInvoice || this.editMode}
                          inputProps={{ maxLength: 25 }}
                          fullWidth
                          helperText={this.state.customFieldInputError}
                          onChange={(e) => this.setCustomJobId(e)}
                        />
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <TextField
                          id="PO"
                          type="text"
                          label={t('PO')}
                          value={this.state.PO}
                          fullWidth
                          onChange={(e) => this.handleChange(e, t)}
                        />
                      </Grid>
                      <Grid item xs={12} md={12} id="Amount">
                        <AmountTextField
                          id="amount"
                          label={t('Amount')}
                          amount={this.state.baseAmount}
                          setAmount={this.handleBaseAmountChange}
                          required
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={6}>
                        <DatePickerInput
                          id="invoice-date-picker"
                          label={t('InvoiceDate')}
                          value={this.state.invoiceDate ? this.state.invoiceDate : new Date()}
                          onChange={(date) => {
                            this.handleDateChange(date, 'invoiceDate');
                          }}
                          format="MM/dd/yyyy"
                          closeOnSelect
                          minDate={
                            this.props?.location?.state?.rowData
                              ? this.props?.location?.state?.rowData?.dateOpened
                              : new Date()
                          }
                          maxDate={this.state.dueDate}
                          variant="outlined"
                          unstyled
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={6}>
                        <DatePickerInput
                          id="due-date-picker"
                          label={t('DueDate')}
                          value={this.state.dueDate}
                          onChange={(date) => {
                            this.handleDateChange(date, 'dueDate');
                          }}
                          format="MM/dd/yyyy"
                          closeOnSelect
                          minDate={this.state.invoiceDate}
                          variant="outlined"
                          unstyled
                        />
                      </Grid>
                    </Grid>
                    <Grid item container rowSpacing={3} direction="row" id="addressFields">
                      {checkAddressEnabled(this.state.addressSettings?.billingAddress) && (
                        <Grid item md={12} sm={12}>
                          <AddressFieldsDropDown
                            align={isSizeMobile ? 'column' : 'row'}
                            type="billing"
                            state={this.state}
                            handleChange={this.handleChangeAddress}
                            handleSameAddress={this.handleIsBillingAddressSameAsShippingAddress}
                          />
                        </Grid>
                      )}
                      {checkAddressEnabled(this.state.addressSettings?.shippingAddress) && (
                        <Grid item md={12} sm={12}>
                          <AddressFieldsDropDown
                            align={isSizeMobile ? 'column' : 'row'}
                            type="shipping"
                            state={this.state}
                            handleChange={this.handleChangeAddress}
                            handleSameAddress={this.handleIsBillingAddressSameAsShippingAddress}
                          />
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                  <Grid item container spacing={1}>
                    {this.props.UserDetail.permissions.displayProducts === true ? (
                      <div className={classes.tableWrapper}>
                        <ProductTable
                          products={this.state.products}
                          productList={this.state.productList}
                          setProducts={(newProducts) => {
                            this.setNewProducts(newProducts);
                          }}
                        />
                      </div>
                    ) : (
                      ''
                    )}
                    <Grid container spacing={1} className="mt-m">
                      <Grid container item xs={12} spacing={3}>
                        <Grid item md={6} xs={12}>
                          <AppBar position="static" color="default">
                            <Tabs
                              value={this.state.tabValue}
                              onChange={(e, val) => {
                                this.setState({ tabValue: val });
                              }}
                              indicatorColor="primary"
                              textColor="primary"
                              variant="fullWidth"
                              aria-label="action tabs example"
                            >
                              <Tab label="Public Notes" {...this.a11yProps(0)} />
                              <Tab label="Private Notes" {...this.a11yProps(1)} />
                              <Tab label="Terms" {...this.a11yProps(2)} />
                            </Tabs>
                          </AppBar>
                          <TabPanel value={this.state.tabValue} index={0}>
                            <Textfield
                              error={this.state.error && this.state.error.publicNotesError}
                              helperText={
                                this.state.errorMessage && this.state.errorMessage.publicNotesErrorMessage
                                  ? this.state.errorMessage.publicNotesErrorMessage
                                  : ''
                              }
                              id="publicNotes"
                              type="text"
                              labels={t('PublicNotes')}
                              value={this.state.publicNotes}
                              width={true}
                              onChange={(e) => this.handleChange(e, t)}
                              multiline={true}
                            />
                          </TabPanel>
                          <TabPanel value={this.state.tabValue} index={1}>
                            <Textfield
                              error={this.state.error && this.state.error.privateNotesError}
                              helperText={
                                this.state.errorMessage && this.state.errorMessage.privateNotesErrorMessage
                                  ? this.state.errorMessage.privateNotesErrorMessage
                                  : ''
                              }
                              id="privateNotes"
                              type="text"
                              labels={t('PrivateNotes')}
                              value={this.state.privateNotes}
                              width={true}
                              rowsMax={'4'}
                              onChange={(e) => this.handleChange(e, t)}
                              multiline={true}
                            />
                          </TabPanel>
                          <TabPanel value={this.state.tabValue} index={2}>
                            <Textfield
                              error={this.state.error.termNotesError}
                              id="termNotes"
                              type="text"
                              labels={t('termNotes')}
                              value={this.state.termNotes}
                              width={true}
                              onChange={(e) => this.handleChange(e, t)}
                              rowsMax={'4'}
                              multiline={true}
                            />
                          </TabPanel>
                          <CustomFileDropzone
                            invoiceId={this.state.invoiceId}
                            customInvoiceFiles={this.state.customInvoiceFiles}
                            handleChangeCustomFiles={this.handleChangeCustomFiles}
                          />
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <Grid container>
                            <FeeDisplay
                              baseAmount={this.state.baseAmount}
                              paymentType={this.state.paymentType}
                              viewAllPrices
                              state={this.state.billingAddress?.state}
                              setCalculationResult={(newCalculationResult) => {
                                this.setState({ calculationResult: newCalculationResult });
                              }}
                              setError={(err) => {
                                this.setState((prevState) => ({
                                  messages: [
                                    ...prevState.messages,
                                    { severity: AlertSeverityTypes.error, message: err?.message },
                                  ],
                                }));
                              }}
                            />
                          </Grid>
                        </Grid>
                        <Grid item xs={12} />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    md={12}
                    xs={12}
                    sm={12}
                    style={{
                      display: this.state.isMobile ? 'none' : '',
                    }}
                  >
                    {!rowData && (
                      <>
                        <Buttons
                          id="emailInvoice"
                          type="submit"
                          variant="contained"
                          className={'emailInvoiceTerminal email-invoice'}
                          onClick={(e) => this.handleSubmitEmailInvoice(e, t)}
                          startIcon={<Icon>send</Icon>}
                          text={t('EmailInvoice')}
                        />
                        {(this.state.userData.permissions.textToInvoice ||
                          this.state.userData.permissions.textInvoice) && (
                          <Buttons
                            id="textInvoice"
                            type="submit"
                            variant="contained"
                            className={'emailInvoiceTerminal textInvoiceBtn'}
                            onClick={(e) => this.handleSubmitTextInvoice(e, t)}
                            startIcon={<Icon>message</Icon>}
                            text={t('TextInvoice')}
                          />
                        )}
                        <Buttons
                          id="signUp"
                          type="submit"
                          variant="contained"
                          color="primary"
                          className={'emailInvoiceTerminal'}
                          disabled={
                            paymentGateway === 'multipass' &&
                            !this.state.ach.isStarted &&
                            !this.state.cardWalletID &&
                            !this.state.tsepFieldSuccess
                          }
                          onClick={(e) => this.handleSubmit(e, false)}
                          startIcon={<Icon>payment</Icon>}
                          text={t('Payment')}
                        />
                        {this.state.feeSettings.DualFeeEnabled ? (
                          <Buttons
                            id="cashPayment"
                            type="submit"
                            variant="contained"
                            className={'emailInvoiceTerminal'}
                            onClick={(e) => this.handleSubmit(e, true)}
                            text="Cash Payment"
                          />
                        ) : (
                          ''
                        )}
                      </>
                    )}

                    {!this.state.isArchived && (
                      <Buttons
                        id="signUp"
                        type="submit"
                        variant="contained"
                        className={'emailInvoiceTerminal'}
                        onClick={(e) => this.handleSubmitSaveDraft(e, t)}
                        startIcon={<SaveIcon />}
                        text={t('SaveDraft')}
                      />
                    )}

                    {rowData &&
                      (this.state.isArchived ? (
                        <Buttons
                          id="restore-button"
                          type="button"
                          variant="contained"
                          className={'emailInvoiceTerminal archivedBtn'}
                          onClick={() => this.updateArchiveStatus(false)}
                          text="Restore"
                        />
                      ) : (
                        <Buttons
                          id="archive-button"
                          type="button"
                          variant="contained"
                          className={'emailInvoiceTerminal archivedBtn'}
                          onClick={() => this.updateArchiveStatus(true)}
                          text="Archive"
                        />
                      ))}

                    <Buttons
                      className={'emailInvoiceTerminal'}
                      variant="contained"
                      color="secondary"
                      text={t('Back')}
                      onClick={this.props.history.goBack}
                    />

                    <Buttons
                      variant="contained"
                      color="primary"
                      className={'emailInvoiceTerminal'}
                      onClick={this.handlePrint.bind(this)}
                      text="Print"
                      startIcon={<PrintIcon style={{ color: 'white' }} className={'printInvoice'} />}
                    />
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                    sm={12}
                    style={{
                      display: this.state.isMobile ? '' : 'none',
                    }}
                  >
                    {!rowData && (
                      <>
                        {this.state.feeSettings.DualFeeEnabled ? (
                          <Grid item s={4} m={4} xs={12} lg={4}>
                            <Buttons
                              id="signUp"
                              type="submit"
                              variant="contained"
                              className={classesI.payment_btn}
                              onClick={(e) => this.handleSubmit(e, false)}
                              startIcon={<Icon>payment</Icon>}
                              text={t('Card')}
                            />
                            {this.state.feeSettings.DualFeeEnabled ? (
                              <Buttons
                                id="cashPayment"
                                type="submit"
                                variant="contained"
                                className={classesI.payment_btn}
                                onClick={(e) => this.handleSubmit(e, true)}
                                text="Cash"
                              />
                            ) : (
                              ''
                            )}
                          </Grid>
                        ) : (
                          <Grid item s={4} m={4} xs={12} lg={4}>
                            <Buttons
                              id="signUp"
                              type="submit"
                              variant="contained"
                              className={classesI.onlycard_btn}
                              onClick={(e) => this.handleSubmit(e, false)}
                              startIcon={<Icon>payment</Icon>}
                              text={t('Card')}
                            />
                          </Grid>
                        )}
                        <Grid item s={4} m={4} xs={12} lg={4}>
                          <Buttons
                            id="emailInvoice"
                            type="submit"
                            variant="contained"
                            className={classesI.email_btn}
                            onClick={(e) => this.handleSubmitEmailInvoice(e, t)}
                            startIcon={<Icon>send</Icon>}
                            text={t('EmailInvoice')}
                          />
                          {(this.state.userData.permissions.textToInvoice ||
                            this.state.userData.permissions.textInvoice) && (
                            <Buttons
                              id="textInvoice"
                              type="submit"
                              variant="contained"
                              className={classesI.email_btn}
                              onClick={(e) => this.handleSubmitTextInvoice(e, t)}
                              startIcon={<Icon>message</Icon>}
                              text={t('TextInvoice')}
                            />
                          )}
                        </Grid>
                      </>
                    )}
                    <Grid item s={4} m={4} xs={12} lg={4}>
                      {!this.state.isArchived && (
                        <Buttons
                          id="signUp"
                          type="submit"
                          variant="contained"
                          className={classesI.draft_print_btn}
                          onClick={(e) => this.handleSubmitSaveDraft(e, t)}
                          startIcon={<SaveIcon />}
                          text={t('SaveDraft')}
                        />
                      )}

                      <Buttons
                        variant="contained"
                        color="primary"
                        className={classesI.draft_print_btn}
                        onClick={this.handlePrint.bind(this)}
                        text="Print"
                        startIcon={<PrintIcon style={{ color: 'white' }} className={'printInvoice'} />}
                      />
                    </Grid>

                    {rowData &&
                      (this.state.isArchived ? (
                        <Buttons
                          id="restore-button"
                          type="button"
                          variant="contained"
                          className={'emailInvoiceTerminal archivedBtn'}
                          onClick={() => this.updateArchiveStatus(false)}
                          text="Restore"
                        />
                      ) : (
                        <Buttons
                          id="archive-button"
                          type="button"
                          variant="contained"
                          className={'emailInvoiceTerminal archivedBtn'}
                          onClick={() => this.updateArchiveStatus(true)}
                          text="Archive"
                        />
                      ))}
                    <Grid item s={4} m={4} xs={12} lg={4}>
                      <Buttons
                        className={classesI.backbtn}
                        variant="contained"
                        color="secondary"
                        text={t('Back')}
                        onClick={this.props.history.goBack}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </form>
              <EditInvoiceConfirmationModal
                DualFeeEnabled={this.state.feeSettings.DualFeeEnabled}
                open={this.state.openEditConfirmationModal}
                handleClose={() => this.setState({ openEditConfirmationModal: false })}
                handleSubmit={this.handleSubmit}
                handleSubmitTextInvoice={(e) => this.handleSubmitTextInvoice(e, t)}
                handleSubmitEmailInvoice={(e) => this.handleSubmitEmailInvoice(e, t)}
                isMobile={this.state.isMobile}
                isPaymentButtonDisabled={this.state.isPaymentButtonDisabled}
              />
            </Container>
          </LoadingOverlay>
        </div>
      </div>
    );
  }
}

const ApplyingStyles = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  return <AddInvoice theme={theme} classes={classes} {...props} />;
};

AddInvoice.propTypes = {
  editData: PropTypes.func,
  settingDataByCompanyId: PropTypes.func,
  getTransactionListTodayData: PropTypes.any,
  classes: PropTypes.any,
  history: PropTypes.any,
  addCustomer: PropTypes.func,
  UserDetail: PropTypes.any,
  t: PropTypes.any,
  PAYTRACE_AWS_PATH: PropTypes.any,
  getCsrfToken: PropTypes.func,
  editCustomer: PropTypes.func,
  info: PropTypes.any,
  getInvoiceNumber: PropTypes.func,
  customerDetailsByCompany: PropTypes.func,
  UserDetailById: PropTypes.func,
  uploadInvoiceFile: PropTypes.func,
  termsAndCondition: PropTypes.any,
  LocationCurrent: PropTypes.any,
  location: PropTypes.any,
  isMobile: PropTypes.bool,
  setTsepAuth: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    info: state.InvoiceReducer,
    UserDetail: state.AdminUserReducer,
    LocationCurrent: state.LocationReducer,
    PAYTRACE_AWS_PATH: state.EnvironmentVariablesReducer.data.PAYTRACE_AWS_PATH,
    termsAndCondition: state.TermsConditionReducer,
  };
}

export default connect(mapStateToProps, {
  settingDataByCompanyId,
  getCsrfToken,
  getTransactionListTodayData,
  UserDetailById,
  editCustomer,
  customerDetailsByCompany,
  getInvoiceNumber,
  uploadInvoiceFile,
  setTsepAuth,
})(withTranslation()(ApplyingStyles));
